<template>
  <!-- 弹窗 -->
  <modal v-show="openModal" @close="() => {!always && close()}" class="lg-modal" :class="{'right-simple-modal': right,'canter-simple-modal': !right}" 
    :mid-modal="middle && !large"
    :big-modal="large" :type="right ?'rightModal' :''">
    <!-- 弹窗-头部 -->
    <template slot="header">
      <h4 class="modal-title">{{title}}</h4>
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="close">
        <md-icon style="color: #333 !important; opacity: 1 !important;">clear</md-icon>
      </md-button>
    </template>
    <!-- 弹窗-主体 -->
    <div v-if="showBody" slot="body" style="margin-top: 12px;min-height: 40px;text-align: left;">
      <slot name="body"></slot>
    </div>
    <!-- 弹窗-底部按钮 -->
    <template slot="footer">
      <slot name="footer-btn"></slot>
      <md-button class="diy-black left-icon" @click="close">{{cancleBtnName ?cancleBtnName :$I18n("cancle")}}</md-button>
      <md-button v-if="submitBtn" class="diy-back-blue md-info" @click="submit">{{submitBtnName ?submitBtnName :$I18n("sure")}}</md-button>
    </template>
  </modal>
</template>
<script>
// 该组件帮助文档
const HELP = `
弹窗组件帮助[2025/07/07]:
  可用参数(props):
    1.always        [Boolean - false]: 默认自动打开,且无法点击周边遮罩关闭, 该参数的切换也可以开关弹窗
    2.title         [String]         : 标题
    3.middle/large  [Boolean - false]: 窗口宽度 [middle:660px , large: 1250px]
    4.right         [Boolean - false]: 窗口是否是右侧窗口(false 为居中)
    5.submitBtn     [Boolean - true] : 是否有确认按钮
    6.submitBtnName [String]         : 确认按钮的文本/默认是sure
    7.cancleBtnName [String]         : 取消按钮的文本/默认是cancle
  可用插件(slot):
    1.body      : 弹窗主体
    2.footer-btn: 底部按钮(若需要'确认'/'取消'外的按钮)
  外部常调用函数(methods):
    1.open : 打开弹窗
    2.close: 关闭弹窗
  外部自定义的函数, 组件可能会调用(emit):
    1.open  : 打开弹窗的时候执行
    2.close : 关闭弹窗的时候执行
    3.submit: 点击'确认'按钮的时候额外执行方法
`
import { Modal } from '@/components';
export default {
  name: "simple-modal",
  components: { Modal },
  props:{
    cancleBtnName:{
      type:String,
      default: "",
    },
    always:{ // 默认不使用 常时打开, true 的时候将无法关闭
      type: Boolean,
      default: false,
    },
    title:{
      type: String,
      default: "",
    },
    middle:{
      type: Boolean,
      default: false,
    },
    large:{ // 大号窗口
      type: Boolean,
      default: false,
    },
    right:{ // 右侧弹窗
      type: Boolean,
      default: false,
    },
    submitBtn:{ // 确认按钮
      type: Boolean,
      default: true,
    },
    submitBtnName: { // 确认按钮的文字
      type: String,
      default: "",
    }
  },
  data(){
    return {
      showBody : this.always,
      openModal: this.always,
    }
  },
  methods:{
    _help(){
      console.log(HELP);
    },
    open(){ // 打开弹窗
      this.openModal = true;
      if(this.$listeners["open"]){
        this.$emit('open');
      }
    },
    close(){ // 关闭弹窗
      if(this.openModal){
        this.openModal = false;
        if(this.$listeners["close"]){
          this.$emit('close');
        }
      }
    },
    submit(){
      if(this.$listeners["submit"]){
        this.$emit('submit');
      }
    },
  },
  watch:{
    always(newValue, oldValue){
      if(newValue === !oldValue){
        if(!newValue){
          this.close();
        } else {
          this.open();
        }
      }
    },
    openModal(open){
      if(open){
        this.showBody = true;
      } else {
        setTimeout(() => {
          if(!this.openModal){
            this.showBody = false;
          }
        }, 1000)
      }
    },
  },
}
</script>
<style scoped>
  .modal-title{
    flex: 1; 
    margin-left: 15px;
    color: #333333; 
    font-size: 17px;
    font-weight: 400;
  }
</style>
<style>
  .right-simple-modal.rigth-modal .modal-container{
    max-width: 540px ;
  }
  .canter-simple-modal .modal-container{
    max-width: 570px ;
  }
  .modal-container .del-msg{
    margin-left: 15px ;
  }
</style>